import { memo } from 'react'
import { ROLES } from 'core/constants/roles'
import { useUserHasRoles } from 'core/hooks/useUserHasRoles'
import { useApiGetForecastByCountryCode } from 'core/api/upward-forecast/useApiGetForecastByCountryCode'
import { useApiPutForecastUnlockButton } from 'core/api/upward-forecast/useApiPutForecastUnlockButton'
import { useTranslation } from 'react-i18next'

interface IUnblockButtonProps {
  isDisabled: boolean
  country: string
}

const UnblockButton = ({ isDisabled, country }: IUnblockButtonProps) => {
  const { t } = useTranslation()
  const { data: dataForecastByCountryCode } = useApiGetForecastByCountryCode({ countryCode: country })
  const isAuthorized = dataForecastByCountryCode ? dataForecastByCountryCode.authorized : false
  const userIsAdmin = useUserHasRoles([ROLES.ROLE_ADMIN])

  const { mutate } = useApiPutForecastUnlockButton()

  const handleOnClick = () => {
    mutate({
      countryCode: country,
      isAuthorized
    })
  }

  return userIsAdmin ? (
    <button
      type="button"
      id={`upward-forecast-${dataForecastByCountryCode?.authorized ? 'authorized' : 'unauthorized'}`}
      className="vtmn-btn vtmn-btn_variant--primary vtmn-btn_size--small"
      onClick={isDisabled ? null : handleOnClick}
      disabled={isDisabled}
    >
      {dataForecastByCountryCode?.authorized ? t('block') : t('unblock')}
    </button>
  ) : null
}

export default memo(UnblockButton)
